import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import usePortal from '../../utils/hooks/usePortal';

/**
 * @example
 * <Portal id="modal">
 *   <p>Thinking with portals</p>
 * </Portal>
 */

type PortalPropTypes = {
    id: string;
    children: any;
};

const Portal: FC<PortalPropTypes> = ({ id, children }) => {
    const target = usePortal(id);

    return createPortal(
        //@ts-ignore
        children,
        (target as unknown as HTMLElement),
    );
};

export default Portal;